export const mapRegistrant = (registrant) => ({
  ...registrant,
  fullName: `${registrant.firstName} ${registrant.lastName}`,
})
